export default __webpack_public_path__ + "locales/fi/ChangeUserTypeDialog.json?hash=1b88c4d9192e3c59c9ae00738edd15c0";